import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { GridForm } from 'components/Ui/styled';
import Grid from '@mui/material/Grid';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  renderSaveCancelButtons,
  getSnackBar,
  useNotification,
  refinePayload,
} from 'utils/commonUtils';
import CustomizedSnackbars from 'components/snackbar/Snackbar';
import {
  getStudentAdditionalInfo,
  putStudentAdditionalInfo,
} from 'layouts/students/service/studentsApi';
import { displaySnackbar } from 'components/snackbar/store/SnackbarSlice';
import { usePermissionCustomHook } from 'layouts/users/userPermissions/utils/permissionsUtils';
import { requiredLimit, characterLimit } from 'constants';

const input_schema = yup.object().shape({
  iepTeacher: yup.string().max(characterLimit, requiredLimit).nullable(),
});

const AdditionalInformation = (props) => {
  const { setExpanded } = props;
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);
  const [studentAdditionalInfo, setStudentAdditionalInfo] = useState();
  const { setOpenNotification, setNotificationMessage, NotificationPopup } =
    useNotification();

  const canUpdateAdditionalInfo = usePermissionCustomHook(
    'CAN_UPDATE_ADDITIONAL_INFO'
  );

  const studentId = useSelector(
    (state) => state.studentDetails?.item?.studentId
  );

  useEffect(() => {
    if (studentId) {
      fetchStudentAdditionalInfo();
    }
  }, [studentId]);

  const fetchStudentAdditionalInfo = async () => {
    const studentAdditionalInfoData = await getStudentAdditionalInfo(studentId);
    setStudentAdditionalInfo(studentAdditionalInfoData);
  };

  const defaultValue = {
    iepTeacher: studentAdditionalInfo?.item?.iepTeacher,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(input_schema),
  });

  const { handleSubmit, reset, control, formState } = useFunction;
  const { errors } = formState;

  useEffect(() => {
    reset(defaultValue);
  }, [defaultValue.iepTeacher]);

  const handleClose = () => {
    setExpanded(false);
    reset(defaultValue);
  };

  const onSubmit = async (data) => {
    setLoadingButton(true);
    const { iepTeacher } = data;
    const message = 'Successfully the iep teacher is saved';
    const snackBar = getSnackBar(message);

    const rawPayload = { iepTeacher };
    const payload = {
      data: refinePayload(rawPayload),
    };
    try {
      await putStudentAdditionalInfo(payload, studentId);
      setExpanded(false);
      fetchStudentAdditionalInfo();
      dispatch(displaySnackbar(snackBar));
    } catch (error) {
      setOpenNotification(true);
      setNotificationMessage(error?.response?.data?.message);
    }
    setLoadingButton(false);
  };

  return (
    <>
      <CustomizedSnackbars />
      <GridForm container spacing={2}>
        <Grid item xs={3}>
          <FormInputText
            name="iepTeacher"
            type="text"
            control={control}
            label="Iep Teacher"
            readOnly={!canUpdateAdditionalInfo}
            helperText={errors?.iepTeacher?.message}
            errors={!!errors.iepTeacher}
          />
          {canUpdateAdditionalInfo &&
            renderSaveCancelButtons(
              handleClose,
              handleSubmit(onSubmit),
              loadingButton
            )}
        </Grid>
      </GridForm>
      <NotificationPopup />
    </>
  );
};

export default AdditionalInformation;
